import { GraphQLClient } from 'graphql-request';
import { authManager } from 'lib-shared-auth';
import { config } from 'lib-shared-backend-config';

const getEndpoint = () => {
  const domain = config.url.smartConversationReply;
  return `${domain}/management/api/alpha/graphql`;
};

export interface KnowledgeBaseResult {
  id: string;
  name: string;
  isActive: boolean;
}

interface KnowledgeBaseResponse {
  helpCenters: {
    results: KnowledgeBaseResult[];
  };
}

const query = `
  query HelpCenters() {
    helpCenters() {
      results {
          id
          name
          isActive
      }
    }
  }
`;

export const fetchInternalKnowledgeData = async (): Promise<
  KnowledgeBaseResult[]
> => {
  const data = await authManager.getAuthData();
  const authorizationToken = `Bearer ${data!.access_token}`;

  const client = new GraphQLClient(getEndpoint(), {
    headers: {
      authorization: authorizationToken,
    },
  });

  try {
    const data: KnowledgeBaseResponse = await client.request(query);
    return data.helpCenters.results;
  } catch (error) {
    return [];
  }
};
